import { render, staticRenderFns } from "./ObserveIntersection.vue?vue&type=template&id=7a0767df&"
import script from "./ObserveIntersection.vue?vue&type=script&lang=js&"
export * from "./ObserveIntersection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports